import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { referFriendEmailValidationError } from '../../utils/berkeleyEmailAccess';
import './UserMenuCollagesSection.css';

/**
 * Friend email entry dialog for the collage-a-friend flow (navbar user menu or invite-by-email).
 */
export default function CollageFriendModal({ open, onClose, onCollageFriendStart }) {
  const [friendEmailInput, setFriendEmailInput] = useState('');
  const [friendEmailError, setFriendEmailError] = useState('');
  const [friendEmailSubmitting, setFriendEmailSubmitting] = useState(false);

  useEffect(() => {
    if (!open) return;
    setFriendEmailInput('');
    setFriendEmailError('');
    setFriendEmailSubmitting(false);
  }, [open]);

  const closeModal = () => {
    if (friendEmailSubmitting) return;
    onClose?.();
  };

  if (!open || typeof onCollageFriendStart !== 'function') return null;

  return createPortal(
    <div
      className="user-menu-match-removal-confirm-overlay"
      role="presentation"
      onClick={closeModal}
    >
      <div
        className="user-menu-match-removal-confirm cart-popup vibe-popup user-menu-coupon-redeem-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="user-menu-collage-friend-email-title"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="cart-popup-close"
          aria-label="Close"
          onClick={closeModal}
        >
          ×
        </button>
        <h3 id="user-menu-collage-friend-email-title" className="match-explainer-title user-menu-match-removal-confirm-title">
          Collage a friend
        </h3>
        <p className="user-menu-coupon-redeem-hint">
          Enter your friend&apos;s email. You&apos;ll build a collage for them next.
        </p>
        <form
          className="user-menu-coupon-redeem-form"
          onSubmit={async (e) => {
            e.preventDefault();
            if (friendEmailSubmitting) return;
            const err = referFriendEmailValidationError(friendEmailInput);
            if (err) {
              setFriendEmailError(err);
              return;
            }
            const trimmed = String(friendEmailInput).trim();
            setFriendEmailSubmitting(true);
            try {
              const ok = await onCollageFriendStart(trimmed);
              if (ok === false) return;
              onClose?.();
            } finally {
              setFriendEmailSubmitting(false);
            }
          }}
        >
          <input
            type="email"
            className="user-menu-coupon-redeem-input user-menu-friend-email-input"
            value={friendEmailInput}
            onChange={(e) => {
              setFriendEmailInput(e.target.value);
              if (friendEmailError) setFriendEmailError('');
            }}
            placeholder="friend@example.com"
            autoComplete="email"
            inputMode="email"
            aria-invalid={!!friendEmailError}
            aria-describedby={friendEmailError ? 'user-menu-collage-friend-email-err' : undefined}
            disabled={friendEmailSubmitting}
          />
          {friendEmailError ? (
            <p id="user-menu-collage-friend-email-err" className="user-menu-coupon-redeem-error" role="alert">
              {friendEmailError}
            </p>
          ) : null}
          <div className="user-menu-match-removal-confirm-actions user-menu-coupon-redeem-actions">
            <button
              type="button"
              className="vibe-popup-btn match-flow-close-btn"
              onClick={closeModal}
            >
              Cancel
            </button>
            <button type="submit" className="vibe-popup-btn" disabled={friendEmailSubmitting}>
              {friendEmailSubmitting ? 'Saving…' : 'Continue'}
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body,
  );
}
